export default {
  getLinks: (state) => state.links,
  getSubscription: (state) => state.subscription,
  getSegments: (state) => state.segments,
  getFunctionalities: (state) => state.functionalities,
  getFunctionalitiesBlockedByAdmin: (state) => state.functionalitiesBlockedByAdmin,
  getIsLoadingFunctionalities: (state) => state.isLoadingFunctionalities,
  getPlans: (state) => state.plans,
  getPageInfo: (state) => state.pageInfo,
};
